import { NumberInput, type NumberInputProps } from "@mantine/core";
import classNames from "classnames";
import type { CommonFormFieldItemProps } from "../FormField";
import { FormFieldLabel } from "../FormFieldLabel";
import { FormFieldRightSection } from "../FormFieldRightSection";

interface FormFieldNumberInputProps
  extends CommonFormFieldItemProps, Omit<NumberInputProps, "type"> {
  type: "number";
}

function FormFieldNumberInput({
  helpText,
  highlight,
  isBetaFeature,
  type,
  warned,
  ...fieldSpecificProps
}: FormFieldNumberInputProps) {
  return (
    <NumberInput
      {...fieldSpecificProps}
      aria-label={
        typeof fieldSpecificProps.label === "string"
          ? fieldSpecificProps.label
          : undefined
      }
      className={classNames(
        "FormFieldNumberInput",
        fieldSpecificProps.className
      )}
      defaultValue={undefined}
      hideControls={false}
      label={
        fieldSpecificProps.label && (
          <FormFieldLabel
            helpText={helpText}
            highlight={highlight}
            isBetaFeature={isBetaFeature}
            label={fieldSpecificProps.label}
            required={fieldSpecificProps.required}
          />
        )
      }
      labelProps={{ w: "100%", ...fieldSpecificProps.labelProps }}
      rightSection={
        <FormFieldRightSection
          rightSection={fieldSpecificProps.rightSection}
          warned={warned}
        />
      }
      value={fieldSpecificProps.value ?? fieldSpecificProps.defaultValue ?? ""}
    />
  );
}

export { FormFieldNumberInput, FormFieldNumberInputProps };
